import baseApi from './base';

// 账号管理-修改账号头像
const updateHeadImgs = (id, data) =>
  baseApi.request({
    headers: { 'Content-Type': 'multipart/form-data' },
    method: 'PUT',
    url: `/user/${id}/head-img`,
    data
});

// 账号管理-修改账号密码
const updatePassword = (id, data) =>
  baseApi.request({
    headers: { 'Content-Type': 'multipart/form-data' },
    method: 'PUT',
    url: `/user/${id}/change-password`,
    data
});

// 账号管理-获取账号列表
const fetchUserList = params =>
  baseApi.request({
    method: 'get',
    url: '/user',
    params
  });

// 账号管理-添加账号信息
const createUserList = data =>
  baseApi.request({
    headers: { 'Content-Type': 'multipart/form-data' },
    method: 'post',
    url: '/user',
    data
});

// 账号管理-修改账号信息
const uptateUserList = (id, data) =>
  baseApi.request({
    headers: { 'Content-Type': 'multipart/form-data' },
    method: 'PATCH',
    url: `/user/${id}`,
    data
});

// 账号管理-禁用、启用账号
const disableOne = id =>
  baseApi.request({
    method: 'put',
    url: `/user/${id}/disable-enable`,
  });

// 账号管理-重置账号密码
const resetOne = (id, data) =>
  baseApi.request({
    method: 'put',
    url: `/user/${id}/reset-password`,
    data
  });

// 账号管理-导入账号
const importantUser = data =>
  baseApi.request({
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    responseType: 'blob',
    method: 'put',
    url: '/user/import',
    data
  });

// 账号管理-下载模板
const getTemplate = () =>
  baseApi.request({
    method: 'get',
    url: 'user/download-template',
    responseType: 'blob'
});

// 账号管理-获取账号详情
const getDetail = id =>
  baseApi.request({
    method: 'get',
    url: `/user/${id}`,
});

// 账号管理-获取所有账号
const getAllUser = () =>
  baseApi.request({
    method: 'get',
    url: `/user/all`,
});

// 账号管理-导出账号列表
const exportList = params =>
  baseApi.request({
    method: 'get',
    url: `/user/download`,
    responseType: 'blob',
    params
});

export {
  exportList,
  getAllUser,
  fetchUserList,
  createUserList,
  uptateUserList,
  disableOne,
  resetOne,
  importantUser,
  getTemplate,
  getDetail,
  updatePassword,
  updateHeadImgs
};



// WEBPACK FOOTER //
// ./src/api/user.js